import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const CheckSource = {
  getSetups: function() {
    return axios.get(`${API_BASE}/setups`)
      .then(res => res.data)
  },

  getChecks: function() {
    return axios.get(`${API_BASE}/checks`)
      .then(res => res.data)
  },

  activate: function(params) {
    return axios.post(`${API_BASE}/setups`, { ...params })
      .then(res => res.data)
    // return axios.post(`${API_BASE}/checks/`, { ...params })
    //   .then(res => res.data)
  },

  update: function(id, params) {
    return axios.put(`${API_BASE}/checks/${id}`, { ...params })
      .then(res => res.data)
  }
}

export default CheckSource



// WEBPACK FOOTER //
// ./app/sources/CheckSource.js